import { QuestionnaireContextType } from "@/components/questionnaire/questionnaire.types.ts";
import { createContext, useContext } from "react";

export const QuestionnaireContext = createContext<QuestionnaireContextType | null>(null);

export const useOptionalQuestionnaireContext = (): QuestionnaireContextType | null =>
  useContext(QuestionnaireContext);

export const useQuestionnaireContext = (): QuestionnaireContextType => {
  const context = useOptionalQuestionnaireContext();

  if (!context) {
    throw new Error("useQuestionnaireContext must be used within a QuestionnaireProvider");
  }

  return context;
};
